import type {ColorVariant} from '@gwc/core'
import {Typography} from '@yandex-delivery/blocks'
import React from 'react'

import type {TextWidgetProps as Props} from '../types'

const colorMap: Record<string, ColorVariant> = {
  textMain: 'main',
  textMinor: 'minor',
  error: 'error',
  // TODO: понять, на какой цвет мапить textOnControl
  // textOnControl: ???
}

export const TextWidget = ({config: {color, font_size, font_weight, text}}: Props): React.ReactElement => {
  return (
    <Typography color={colorMap[color]} style={{fontSize: font_size}} thickness={font_weight} variant="body2">
      {text}
    </Typography>
  )
}
